(function () {

// This is the control for the temp pop-up hours. TO RE-ENABLE FOR TEMP HOURS, UNCOMMENT THE CODE MODIFIER IN THEME.LIQUID (NEAR THE BOTTOM)


  if (window.location.pathname !== '/') return;

  if (sessionStorage.getItem('hoursPopupShown')) return;

  window.addEventListener('load', function () {
    const overlay = document.createElement('div');
    overlay.id = 'hours-popup-overlay';

    const popup = document.createElement('div');
    popup.id = 'hours-popup';
    popup.innerHTML = `
      <div id="hours-popup-inner">
        <h2>TEMPORARY OPEN HOURS</h2>

        <div class="popup-sections">
          <div class="popup-column">
            <ul>
              <li>
                <h4><strong>Private Event Notice</strong></h4>
              </li>

              <li>
                <strong>Sunday 9th August</strong> — Full site closed from 12pm.<br><br>

                <strong>Monday 10th August</strong> — Full site closed.<br><br>

                <strong>Tuesday 11th August</strong> — Hotel open. Cellar Door from 10:30am, Provedore from 11:30am and Muse from 4pm.
              </li>
            </ul>

            <div style="margin-top: 1rem; font-style: italic; font-size: 0.95rem; color: #444;">
              *Thanks for your understanding — we look forward to welcoming you back soon.
            </div>
          </div>

          <button id="hours-popup-close">Close</button>
        </div>
      </div>
      `;

    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    requestAnimationFrame(() => {
      overlay.classList.add('visible');
    });

    // ✅ Mark popup as shown for this session
    sessionStorage.setItem('hoursPopupShown', 'true');

    const popupStyle = document.createElement('style');
    popupStyle.innerHTML = `
      #hours-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.5s ease;
        pointer-events: none;
        padding: 20px;
        box-sizing: border-box;
      }
      #hours-popup-overlay.visible {
        opacity: 1;
        pointer-events: auto;
      }
      #hours-popup {
        background: #fff;
        padding: 20px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.25);
        max-width: 1000px;
        max-height: 90vh;
        overflow-y: auto;
        font-family: sans-serif;
        margin-top: 40px;
        text-align: center;
        transform: scale(0.95);
        transition: transform 0.3s ease;
      }
      #hours-popup-overlay.visible #hours-popup {
        transform: scale(1);
      }
      #hours-popup h2 {
        margin: 0 0 15px;
        font-size: 1.5em;
      }
      .popup-sections {
        display: block;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 20px;
      }
      .popup-column {
        width: 300px;
        padding: 10px;
        box-sizing: border-box;
        margin-left: auto;
        margin-right: auto;
      }
      #hours-popup ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
      }
      #hours-popup li {
        margin-bottom: 8px;
        font-size: 1em;
      }
      #hours-popup button {
        background: #000;
        color: #fff;
        border: none;
        padding: 14px;
        min-width: 200px;
        cursor: pointer;
        text-transform: uppercase;
        font-size: 1em;
        margin-top: 10px;
      }
      #hours-popup button:hover {
        background: #333;
      }

      @media (max-width: 768px) {
        #hours-popup {
          padding: 15px;
          margin-top: -20px;
        }
        #hours-popup h2 {
          font-size: 1.2em;
        }
        .popup-column {
          width: 100%;
        }
        #hours-popup li {
          font-size: 0.95em;
        }
        #hours-popup button {
          padding: 12px;
          font-size: 0.9em;
          min-width: 100%;
        }
      }
    `;
    document.head.appendChild(popupStyle);

    function closePopup() {
      overlay.classList.remove('visible');
      setTimeout(() => overlay.remove(), 500);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    document.getElementById('hours-popup-close').addEventListener('click', closePopup);
  });
})();
